module.exports = __webpack_public_path__ + "img/drawing6.8dde42ca.jpg";